const elementLabels = {
  html: "Page background",
  body: "Page background",
  a: "Link",
  button: "Button",
  img: "Image",
  div: "Content area",
  span: "Text element",
  p: "Paragraph",
  section: "Page section",
  main: "Main content",
  header: "Page header",
  footer: "Page footer",
  nav: "Navigation area",
  svg: "Icon",
  path: "Icon detail",
  li: "List item",
  ul: "List",
  ol: "List",
  h1: "Heading",
  h2: "Heading",
  h3: "Heading",
  h4: "Heading",
  h5: "Heading",
  h6: "Heading",
  chatbot_launcher: "Opened chat",
};

export function formatActivityLabel(label) {
  return Object.prototype.hasOwnProperty.call(elementLabels, label)
    ? elementLabels[label]
    : label;
}

export function formatActivityNote({ title, body, color }) {
  const prefix = "Most used action: ";
  if (!title.startsWith(prefix)) return [title, body, color];
  const label = title.slice(prefix.length);
  const displayLabel = formatActivityLabel(label);
  const isElement = displayLabel !== label && label !== "chatbot_launcher";
  return [
    `${isElement ? "Most clicked element" : "Most used action"}: ${displayLabel}`,
    isElement
      ? `${body.replace("target this action", "target this element type")} These clicks have no specific action label.`
      : body,
    color,
  ];
}
